import axios from 'axios';

import { V1_API_URL } from '../config';
import { getAccessToken } from '../helpers';
import { logOut } from '@common/auth';
import { openNotification } from '@common/helpers';
import { PUBLIC_URL } from '@common/config';
import { Modal } from 'antd';

const authHttp = axios.create({
	baseURL: V1_API_URL,
});

authHttp.interceptors.request.use(
	(config) => {
		config.headers['Authorization'] = 'Bearer ' + getAccessToken();
		const businessUnit = localStorage.getItem('businessUnit');
		const costCenterId = localStorage.getItem('costCenterId');
		const companyId = localStorage.getItem('companyId');
		if (businessUnit) {
			config.headers['x-dxc-buid'] = businessUnit;
		}
		if (costCenterId) {
			config.headers['x-dxc-costcenterid'] = costCenterId;
		}
		if (companyId) {
			config.headers['x-dxc-companyid'] = companyId;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

authHttp.interceptors.response.use(
	(response) => {
		return response.data;
	},
	(error) => {
		console.log(error.response);
		if (error.response.status !== 200) {
			if (error.response.status >= 500) {
				openNotification(
					'error',
					'Something went wrong! Please try again later!'
				);
			} else if (
				error.response.status === 403 ||
				error.response.status === 401
			) {
				/*
        openNotification(
          'warning',
          error.response.data.message ? error.response.data.message : error.response.data.messages[0].message,
          true
        );
        */
				Modal.warning({
					title: 'Warning',
					content: 'You have no permission!',
				});
			} else {
				openNotification(
					'warning',
					error.response.data.message
						? error.response.data.message
						: error.response.data.messages[0].message
				);
			}
			return Promise.reject(error);
		}
		return Promise.reject(error);
	}
);

export default authHttp;
